export enum bulkExportStatusEnum {
    QUEUED = 0,
    IN_PROGRESS_STARTED = 3,
    IN_PROGRESS = 5,
    ERROR = 4,
    INTERRUPTED = 7,
    COMPLETED = 1,
    COMPLETED_ARCHIEVED = 2,
    ERROR_ARCHIVED = 6,
    CANCEL_REQUESTED_IN_PROGRESS = 15,
    CANCEL_REQUESTED_INTERRUPTED = 17,
    CANCELLED = 9
} 